import script from "./InitialCampaignMixin.vue?vue&type=script&lang=ts"
export * from "./InitialCampaignMixin.vue?vue&type=script&lang=ts"

export default script